<template>
  <div  class="ritchHtml" style="padding-left:20px">
    <div v-html="valueHtml"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      valueHtml: ""
    };
  },
  created() {
    this.$http({
      url: "api/v1/configs/value",
      method: "get",
      params: { name: 'about_course' }
    }).then(res => {
      if (res.status == 200) {
        if (res.data.value) {
          this.valueHtml = res.data.value;
        }
      } else {
        this.$message.error(res.msg);
      }
    });
  }
};
</script>

<style>
</style>